import React, { useEffect } from 'react';
import { useSpotlightStore } from '../../store/spotlightStore';
import { motion } from 'framer-motion';

export const CreditBalanceBadge: React.FC = () => {
  const { credits, fetchCredits } = useSpotlightStore();

  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  return (
    <motion.div 
      initial={{ scale: 0.95, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="flex items-center gap-2 px-3 py-1.5 bg-surface border border-border rounded-full hover:bg-surface/80 transition-colors cursor-pointer group"
      title="Your Spotlight Credits"
    >
      <div className="w-5 h-5 rounded-full bg-accent/20 flex items-center justify-center text-accent group-hover:bg-accent group-hover:text-white transition-colors">
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <span className="font-semibold text-sm text-textTertiary">
        {credits.toLocaleString()}
      </span>
    </motion.div>
  );
};
